export default __webpack_public_path__ + "static/media/bin_white.9e261fc0.svg";